import { IOpOperacja, IOpParent, OpTouchEnum, IOpModifier } from "./IOp";
import { IOpServer } from "./IOpServer";
import { OpArray, IPoso, OpTouchCallback } from "./OpArray"
import { OpColor } from "./OpColor";
import { OpEtap } from "./OpEtap";
import { OpKomponent } from "./OpKomponent";
import { OpOperacja } from "./OpOperacja";
import { OpParent } from "./OpParentOld";




export class OpController {

    private operacje: IOpOperacja[] = []
   
    private modified: IOpModifier[] = []
    private parent: IOpParent | undefined = undefined
    private op_server: IOpServer | undefined = undefined

    async init(parent: IOpParent, operacje: IOpOperacja[], op_server: IOpServer) {
       
        this.modified = []
        this.operacje = operacje;
        this.parent   = parent

        this.op_server = op_server
    }


    async copy_operacje(from: OpController) {

        console.log("******************* START copy_operacje")
        OpArray.sort(this.operacje)

        let etap: IOpOperacja | undefined
        let counter=0
        const len=from.operacje.length
        for (let i=0;i<len && counter<30;i++) {
            console.log("******************* copy_operacje i=",i,"from.operacje.length",from.operacje.length)

            const op_from=from.operacje[i]
            const op_json = JSON.stringify(op_from)
            const op:IOpOperacja = JSON.parse(op_json)
            op.parent = this.parent
            delete op._id

            if (op.etap) {
                etap=op
                //console.log("ADD ETAP", JSON.stringify(op.parent),JSON.stringify(from.parent))
                await this.add_new_etap(etap) 
            } else {
                if (etap) {
                    //console.log("ADD OPERACJA", JSON.stringify(op.parent),JSON.stringify(from.parent))
                    await this.add_operacja_to_etap(op, etap) 
                }
            }
            counter++

        }

    }

    create_etap(etap_typ: string, grupa_maszyn:string): IOpOperacja {
        const op = new OpOperacja()
        op.color = new OpColor()
        op.etap = new OpEtap()
        op.etap.etap_typ = etap_typ
        op.etap.grupa_maszyn = grupa_maszyn
        op.color.etap_graflow = etap_typ
        op.poso = undefined
        op.ide = undefined
        op._id = undefined
        op.parent = this.parent
        return op;
    }

    is_newfoil(operacja:IOpOperacja) {
        if (!operacja.color) return 0;
        
        if (
            operacja.color.technologia_graflow == 'hs nf' ||
            operacja.color.technologia_graflow == 'hs tłoczenie nf' ||
            operacja.color.technologia_graflow == 'tłoczenie nf' ||
            operacja.color.technologia_graflow == 'hs microembossing nf' ||
            operacja.color.technologia_graflow == 'microembossing nf'
         ) return 1;
        
         return 0;
    }

    create_operacja(typ: string, etap_op: IOpOperacja, nazwa: string): IOpOperacja {
        const op = new OpOperacja()
        op.color = new OpColor()
        op.etap=undefined
        op.color.kolor = typ
        if (nazwa)  op.color.nazwa = nazwa
        else op.color.nazwa = "DODANY_W_GRAFLOW"

        op.komponent = new OpKomponent()
        if (etap_op.etap) {
            op.color.etap_graflow = etap_op.etap.etap_typ
            op.color.etap = etap_op.etap.etap_typ
        }
        op.color.technologia_graflow = typ
        op.color.technologia = typ

        op.poso = undefined
        op.ide = undefined
        op._id = undefined
        op.parent = this.parent

        if (this.is_newfoil(op)) op.newfoil_params = {
            newfoil_x:0,
            newfoil_y:0,
            newfoil_z:0,
            newfoil_u:0,
            newfoil_koszt_płytki:0,
            newfoil_koszt_matrycypatrycy:0
        }

        return op;
    }



    async add_new_etap(etap_new:IOpOperacja) {

        OpArray.sort(this.operacje)
        let l = this.operacje.length
        if (l == 1) { 
            if (this.operacje[0].dummy) this.operacje.pop()
            l = this.operacje.length
        }

        
        if (l == 0) {
            console.log("\n>>> add new etap", etap_new.etap?.etap_typ)
            await this.insert_after(undefined, etap_new)
            console.log("\n>>> add new etap END", etap_new.etap?.etap_typ)
        } else {
            const op_last = this.operacje[l - 1]
            console.log("\n>>> add new etap", etap_new.etap?.etap_typ)
            await this.insert_after(op_last, etap_new)
            console.log("\n>>> add new etap END", etap_new.etap?.etap_typ)
        }
    }

    async add_operacja_to_etap(op_new: IOpOperacja, etap_op: IOpOperacja) {
        console.log("\n>>> add operacja to etap")
        const etap_pos = OpArray.get_i_by_poso(this.operacje, etap_op.poso, 0)
        console.log('etap_pos', etap_pos)
        if (etap_pos == -1) return undefined;
        console.log(etap_op.poso, this.operacje[etap_pos].poso)
        // etap is the last element
        if (etap_pos == this.operacje.length - 1) {
            console.log(etap_pos, "A insert op", 0, op_new.color?.technologia_graflow)
            await this.insert_after(etap_op, op_new)
            return
        }

        for (let i = etap_pos + 1; i < this.operacje.length; i++) {
            const op = this.operacje[i]
            // next etap => add before
            if (op.etap) {
                console.log(etap_pos, "B insert op", i - 1, op_new.color?.technologia_graflow, op.etap.etap_typ)
                if (i - 1 >= 0) await this.insert_after(this.operacje[i - 1], op_new)
                return
            }
            
        }

        for (let i = etap_pos + 1; i < this.operacje.length; i++) {
            const op = this.operacje[i]
            // last op => add before
            if (i == this.operacje.length - 1) {
                console.log(etap_pos, "C insert op", i, op_new.color?.technologia_graflow)
                await this.insert_after(this.operacje[i], op_new)
                for (let j = 0; j < this.operacje.length; j++) {
                    // console.log("POSO",this.operacje[j].poso, this.operacje[j].etap?.etap_typ, this.operacje[j].color?.technologia)
                }
                return
            }
        }
        console.log("\n>>> add operacja to etap end")
    }


    async insert_after(o_prev: IPoso | undefined, o_new: IPoso) {
        OpArray.insert_after(this.operacje, this.modified, o_prev, o_new)
        await this.save()
    }


    async update(o: IPoso, prop: string | undefined, prop_old_value: any | undefined, prop_new_value: any | undefined) {
        OpArray.update(this.operacje, o)
        this.modified.push({op:o, touch:OpTouchEnum.UPDATE, prop:prop, prop_old_value:prop_old_value, prop_new_value:prop_new_value,filter:undefined, user:undefined,status:OpTouchEnum.NO_ACTION })
        await this.save()
    }


    async move_up(o: IOpOperacja) {
        const o_prev: IPoso | undefined = OpArray.get_by_poso(this.operacje, o.poso, -1)
        if (!o_prev) return;
        if (o.etap) return;

        if ((<IOpOperacja>o_prev).etap) return;
        await this.move_before(o_prev, o)

    }

    async move_down(o: IOpOperacja) {
        const o_next: IPoso | undefined = OpArray.get_by_poso(this.operacje, o.poso, 1)
        if (!o_next) console.log("next is null")
        if (!o_next) return;
        if (o.etap) return;
        if ((<IOpOperacja>o_next).etap) return;
        await this.move_after(o_next, o)
    }


    async move_before(o_prev: IPoso, o: IPoso) {
        OpArray.move_before(this.operacje, this.modified, o_prev, o)
        await this.save()
    }

    async move_after(o_next: IPoso, o: IPoso) {
        OpArray.move_after(this.operacje, this.modified, o_next, o)
        await this.save()
    }

    async remove(op: IPoso) {
        OpArray.remove(this.operacje, this.modified, op)
        await this.save()
    }

    async remove_etap(etap_op: IPoso) {

        const etap_pos = OpArray.get_i_by_poso(this.operacje, etap_op.poso, 0)
        if (etap_pos == -1) return undefined;


        let max_pos=etap_pos
        for (let i = etap_pos+1; i < this.operacje.length && !this.operacje[i].etap; i++) {
            const op = this.operacje[i]
            console.log("************",op.color?.nazwa)
            max_pos++;
        }

        console.log("******************************** remove operacja etap, i from:", etap_pos, "i to:", max_pos)

        for (let i = max_pos; i >= etap_pos && i>=0; i--) {
            const op = this.operacje[i]
            console.log("***************** remove operacja etap, poso:", op.poso)
            await this.remove(op)
        }
    }

    async save() {
        //console.log("OpController save START")
        if (!this.op_server) return;
        if (!this.modified.length) console.log("modified.lenght=0")

        OpArray.sort(this.operacje)

        //console.log("OpController before call op_server.save_changed")

        
        
        
        for (let i=0;i<this.modified.length;i++) {
            const p = (<OpParent> this.modified[i].op.parent)    
            const op = this.modified[i].op
        }
        
        const modified_saved = await this.op_server.save_changed(this.modified, this.operacje)
        //console.log("OpController after  call op_server.save_changed")


        //console.log("OpController after save changed")
        if (modified_saved.length == this.modified.length) {
            for (let i = 0; i < modified_saved.length; i++) {
                if (modified_saved[i].status == OpTouchEnum.NO_ACTION)  { 
                    if (modified_saved[i].touch == OpTouchEnum.UPDATE) {
                        // update error: rollback property change
                        const prop = this.modified[i].prop
                        
                        if (prop) { 
                            console.log('update error: rollback property change',this.modified[i].op[prop], this.modified[i].prop_old_value)
                            this.modified[i].op[prop] = this.modified[i].prop_old_value
                        }

                    }
                    this.modified[i].op.touch =  OpTouchEnum.NO_ACTION
                } else {
                    this.modified[i].op.version =  modified_saved[i].op.version
                    this.modified[i].op._id =  modified_saved[i].op._id
                    //this.modified[i].op.komponent =  modified_saved[i].op.komponent
                    this.modified[i].op.touch =  OpTouchEnum.NO_ACTION
                }
            }
        } 

        this.modified = []
        //console.log("OpController save END")

    }

}